import { ModuleFE_RuntimeProtocol } from './ModuleFE_RuntimeProtocol.js';
export const ModulePackFE_RuntimeProtocolDB = [ModuleFE_RuntimeProtocol];
//# sourceMappingURL=module-pack.js.map